import React from 'react';
import StatusPillStyled from './StatusPill.styled';

export interface StatusPillProps {
  text: string;
  color?: StatusPillColors;
  isHollow?: boolean;
}

export enum StatusPillColors {
  Blue = 'blue',
  Teal = 'teal',
  Charcoal = 'charcoal',
  Cobalt = 'cobalt',
  Grey = 'grey',
  Green = 'green',
  Pink = 'pink',
  Orange = 'orange',
  Violet = 'violet',
  Red = 'red',
  Ruby = 'ruby',
  Yellow = 'yellow',
}

const StatusPill = ({
  isHollow = false,
  color = StatusPillColors.Grey,
  text,
}: StatusPillProps) => {
  return (
    <StatusPillStyled
      className={`status-pill status-pill--${
        isHollow ? 'hollow' : 'solid'
      } status-pill--${color}`}
    >
      <span>{text}</span>
    </StatusPillStyled>
  );
};

export default StatusPill;
